import { render, staticRenderFns } from "./PartCategoryList.vue?vue&type=template&id=00bbd50e"
import script from "./PartCategoryList.vue?vue&type=script&lang=js"
export * from "./PartCategoryList.vue?vue&type=script&lang=js"
import style0 from "./PartCategoryList.vue?vue&type=style&index=0&id=00bbd50e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports